import { LibraryStore } from '@stores/Library/Library';
import css from './LibraryIconStack.module.scss';
import { LibraryIcon } from './components/LibraryIcon/LibraryIcon';

export const LibraryIconStack = ({
  maxVisible,
  libraries,
  size,
}: {
  size: number;
  maxVisible: number;
  libraries: (LibraryStore & { data: NonNullable<LibraryStore['data']> })[];
}) => {
  const visibleLibraries = libraries.slice(0, maxVisible);
  const remainingCount = libraries.length - maxVisible;
  const overlap = 8;

  return (
    <div
      className={css.libraryIconStack}
      style={{
        width: `${size + (visibleLibraries.length - 1) * overlap + overlap * Math.min(1, remainingCount)}px`,
      }}
    >
      {visibleLibraries.map((library, index) => (
        <LibraryIcon
          key={library.libraryId}
          library={library}
          zIndex={index}
          marginLeft={0}
          style={{
            transform: `translateX(${index * overlap}px)`,
          }}
        />
      ))}

      {remainingCount > 0 && (
        <div
          className={css.remainingCount}
          style={{
            zIndex: maxVisible,
            transform: `translateX(${maxVisible * overlap}px)`,
          }}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  );
};
